import axios from 'axios';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../utils/Modal';

const MusicDownload = ({track}) => {
    const navigate = useNavigate();
  
  const user_subscribed_status = useSelector((state)=>state?.auth?.userData?.user_subscribed)
const token = useSelector((state)=>state?.auth?.authToken)
const [showModal,setShowModal] = useState("");
const [userSubscribe, setUserSubscribe] = useState(false)
const closeModal = () => setShowModal(false);

const handleDownloadClick = async (event) => {
        if (!token) {
          event.preventDefault(); 
          setShowModal(true); 
        } else if (user_subscribed_status == false) {
          event.preventDefault(); 
          setShowModal(true); 
          setUserSubscribe(true);
          // window.location.to = "/licenses"; 
          // navigate('/licenses')
        } else {
          // Proceed with download tracking via API
          try {
            // Send a POST request to track the download
            await axios.post(process.env.REACT_APP_API_KEY + '/api/save-download-music', {
              music_id: track.id, 
              // user_id: 1, 
            }, {
              headers: {
                'Authorization': `Bearer ${token}`, 
              },
            });
             
            window.location.href = track.url; 
          } catch (error) {
            console.error('Error tracking download:', error);
           
          }
        }
      };

  return (
    <div className="download-tab">
    <Link
     to={track.url} download
      onClick={handleDownloadClick}>
      <img src="/assets/img/download-ico.svg" alt="Download" />
    </Link>
    <span className="sr-only">Download</span>

    {showModal && 
    <Modal
        userSubscribe={userSubscribe}
        show={showModal}
        handleClose={closeModal}
        logInHandler={() => (window.location.to = "/login")}
        pathName="music"
      />}

  </div>
  )
}

export default MusicDownload